<!--Info-->
<div class="InfoGrid">
	<h4>Group Name:</h4>
	<h4 class="InfoText">{{ GroupName }}</h4>
</div>

<!--Automatically assigned-->
<div class="SubMenu">
	<h4>Added by Default:</h4>
	<label>These actions are automatically assigned to new students joining the group. (Can be edited by changing Prompt Type)</label>

	<div class="TopMargin">
		<caass-assign-default-actions [SelectedGroup]="SelectedGroup"> </caass-assign-default-actions>
	</div>
</div>

<!--Pick optional Actions-->
<div class="SubMenu">
	<h4>Optional Group Actions:</h4>
	<label>Select which group actions to add to the students being assigned to the group and press assign. (Can be edited by changing Prompt Type)</label>

	<div class="TopMargin">
		<caass-assign-optional-actions [SelectedGroup]="SelectedGroup"> </caass-assign-optional-actions>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAssign()">Assign</button>
	<button class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>
